import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loading-block',
  templateUrl: './loading-block.component.html',
  styleUrls: ['./loading-block.component.scss']
})
export class LoadingBlockComponent implements OnInit {
  @Input() isLoading = false;
  constructor() { }

  ngOnInit() {
  }

}

